import { render } from "./NewPredictionPreview.vue?vue&type=template&id=4bf0047a&scoped=true&ts=true"
import script from "./NewPredictionPreview.vue?vue&type=script&lang=ts"
export * from "./NewPredictionPreview.vue?vue&type=script&lang=ts"

import "./NewPredictionPreview.vue?vue&type=style&index=0&id=4bf0047a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf0047a"]])

export default __exports__